const config = {
    cookieName: 'Fusion-Platform',
    cookieConfigValues: {
        findmore: ['findmore-fusion', 'findmore-fusion-aurora'],
        csc: ['csc-fusion'],
    },
    findmore: {
        content: 'EXIT TO POS',
        message: {
            type: 'FROM_PAGE',
            text: 'EXITTOPOS',
        },
    },
    csc: {
        content: 'Sign out',
        link: 'https://posf-cloud.jcpenney.com/launchpad',
    },
};

export default config;
